// Customer Story — Hero (Figma 7620:32063 / 4287:45483).
// Centred "Customer Story" eyebrow + display headline on a grey-50 surface
// with a bottom hairline, sitting flush under the fixed nav.

import { TitleHero } from "@/components/blocks/title-hero";

interface CustomerStoryHeroProps {
  /** Small eyebrow above the title — always "Customer Story" per Figma. */
  eyebrow: string;
  /** Display headline. */
  title: string;
}

export function CustomerStoryHero({ eyebrow, title }: CustomerStoryHeroProps) {
  return (
    <TitleHero
      headlineScale="listing"
      eyebrow={eyebrow}
      title={title}
      sectionTestId="customer-story-hero"
      contentClassName="gap-3 lg:gap-5"
    />
  );
}
